import { FC } from 'react'
import { AppHead } from 'client/components/Layout/components/AppHead/AppHead'
import { ProductPageContent } from 'client/contents/ProductPageContent/ProductPageContent'

type TProps = {}

const ProductPage: FC<TProps> = () => {
  return (
    <article className="bg-surface-white flex h-full w-full flex-col">
      <AppHead />
      <ProductPageContent />
    </article>
  )
}

export default ProductPage
